import { render, staticRenderFns } from "./Ecosystem.vue?vue&type=template&id=e50f6892&scoped=true&"
import script from "./Ecosystem.vue?vue&type=script&lang=js&"
export * from "./Ecosystem.vue?vue&type=script&lang=js&"
import style0 from "./Ecosystem.vue?vue&type=style&index=0&id=e50f6892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50f6892",
  null
  
)

export default component.exports